import React from "react";
import { useNavigate } from "react-router";
import SelectedServices from "./SelectedServices";

const HomepageSelectedService = (props) => {
    let navigate = useNavigate();
    const { selected_pickup, selected_dropoff,services } = props;


    const selectService = (selected_pickup,selected_dropoff) => {
        navigate(`/service/${selected_dropoff}_to_${selected_pickup}`);
    }

    return (
        <React.Fragment>
            <div className="bg-[#F8F8F8] p-6 sm:p-8 md:p-12">
                <div className="bg-white p-6 sm:p-10 md:p-12 border border-[#243c5a]/[.05] text-center rounded-lg shadow-sm">
                    <h3 className="text-[#264796] font-semibold text-lg sm:text-xl mb-4">
                        Click Next if you are happy with your selection
                    </h3>
                    <SelectedServices selected_dropoff={selected_dropoff} selected_pickup={selected_pickup} selected_service={services.filter(value => value.value === selected_pickup)} services={services} />
                </div>

                {/* Button */}
                <div className="flex justify-center md:justify-end mt-6">
                    <button
                        disabled={!(selected_pickup && selected_dropoff)}
                        onClick={() => selectService(selected_pickup, selected_dropoff)}
                        className={`w-full md:w-40 px-4 py-2 rounded font-semibold text-white transition duration-300 ${(selected_pickup && selected_dropoff)
                                ? 'bg-[#2B549A] hover:bg-[#1D2953]'
                                : 'bg-[#E6E7E8] cursor-not-allowed'
                            }`}
                    >
                        Next
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
}

export default HomepageSelectedService;